document.addEventListener('DOMContentLoaded', () => {
    const productCards = document.querySelectorAll('.byob-product-col');
    const progressEl = document.getElementById('byob-progress');
    const addBtn = document.getElementById('byob-add-to-cart');
    const comparePriceEl = document.getElementById('byob-compare-price');
    const finalPriceEl = document.getElementById('byob-final-price');
    const selectedImageBoxes = document.querySelectorAll('.byob-selected-image');
    const imageContainer = document.querySelector('.byob-selection-image');
    const offerTitleEl = document.getElementById('byob-offer-title');
    const offerMessageEl = document.getElementById('byob-offer-message');
    const MAX_PRODUCTS = 8;
    let selectedVariants = [];

    productCards.forEach(card => {
        if (card.dataset.available === 'false') {
            card.classList.add('sold-out');

            const btn = card.querySelector('.add-to-cart-byob');
            if (btn) {
                btn.innerText = 'Sold Out';
                btn.disabled = true;
            }
        }
    });

    function formatPrice(price) {
        return '₹' + Number(price).toLocaleString('en-IN');
    }

    function resetSelections() {
        selectedVariants = [];
        productCards.forEach(card => {
            card.classList.remove('is-selected');
        });
        updateUI();
    }
    
    function updateSelectedImages() {
        selectedImageBoxes.forEach((box, index) => {
            box.innerHTML = '';
            box.style.display = 'flex';

            if (selectedVariants[index]) {
                const product = selectedVariants[index];

                box.innerHTML = `
                    <div class="byob-selected-item">
                        <img src="${product.image}" alt="">
                        <button class="byob-remove-product" data-id="${product.id}" type="button"> x </button>
                    </div>
                `;
            }
        });
    }


    function calculateB1G1Price() {
        const sortedProducts = [...selectedVariants].sort((a, b) => Number(b.price) - Number(a.price));
        const totalOriginalPrice = selectedVariants.reduce((total, product) => total + Number(product.price), 0);
        const freeProductCount = Math.floor(selectedVariants.length / 2);
        const payableProductCount = selectedVariants.length - freeProductCount;
        const payableProducts = sortedProducts.slice(0, payableProductCount);
        const finalPrice = payableProducts.reduce((total, product) => total + Number(product.price), 0);

        return {
            totalOriginalPrice,
            finalPrice,
            freeProductCount
        };
    }


    function updatePrices() {
        if (selectedVariants.length === 0) {
            comparePriceEl.innerHTML = '';
            finalPriceEl.innerHTML = '';
            return;
        }

        const {totalOriginalPrice, finalPrice, freeProductCount} = calculateB1G1Price();

        if (freeProductCount > 0) {
            comparePriceEl.innerHTML = `<span style="text-decoration: line-through;"> ${formatPrice(totalOriginalPrice / 100)} </span>`;
        } else {
            comparePriceEl.innerHTML = '';
        }

        finalPriceEl.innerHTML = `
            <span>${formatPrice(finalPrice / 100)}</span>
        `;
    }


    function updateOfferMessage() {
        const count = selectedVariants.length;

        if (count === 0) {
            offerTitleEl.innerText = 'Select 2 products';
            offerMessageEl.innerText = 'Buy 1 Get 1 FREE';
            return;
        }

        if (count === 1) {
            offerTitleEl.innerText = 'Add 1 more product';
            offerMessageEl.innerText = 'Your second product will be FREE';
            return;
        }

        if (count === 2) {
            offerTitleEl.innerText = '1 Product FREE!';
            offerMessageEl.innerText = 'Add 2 more and pay for only 2';
            return;
        }

        if (count === 3) {
            offerTitleEl.innerText = 'Add 1 more product';
            offerMessageEl.innerText = 'Get 2 products FREE in total';
            return;
        }

        if (count === 4) {
            offerTitleEl.innerText = '2 Products FREE!';
            offerMessageEl.innerText = 'Add 2 more and pay for only 3';
            return;
        }

        if (count === 5) {
            offerTitleEl.innerText = 'Add 1 more product';
            offerMessageEl.innerText = 'Get 3 products FREE in total';
            return;
        }

        if (count === 6) {
            offerTitleEl.innerText = '3 Products FREE!';
            offerMessageEl.innerText = 'Add 2 more and pay for only 4';
            return;
        }

        if (count === 7) {
            offerTitleEl.innerText = 'Add 1 more product';
            offerMessageEl.innerText = 'Get 4 products FREE in total';
            return;
        }

        if (count === 8) {
            offerTitleEl.innerText = '4 Products FREE!';
            offerMessageEl.innerText = 'Maximum offer unlocked';
        }
    }


    function updateUI() {
        const selectedCount = selectedVariants.length;
        progressEl.style.width = ((selectedCount / MAX_PRODUCTS) * 100) + '%';
        addBtn.disabled = selectedCount < 2 || selectedCount % 2 !== 0;

        updateSelectedImages();
        updatePrices();
        updateOfferMessage();

        document.querySelectorAll('.byob-remove-product').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const variantId = btn.dataset.id;
                selectedVariants = selectedVariants.filter(
                    item => item.id !== variantId
                );

                productCards.forEach(card => {
                    if (card.dataset.variantId === variantId) {
                        card.classList.remove('is-selected');

                        const cartBtn = card.querySelector('.add-to-cart-byob');
                        if (cartBtn) {
                            cartBtn.innerText = 'Add to Box';
                        }
                    }
                });
                updateUI();
            });
        });
    }

   // PRODUCT CLICK
    productCards.forEach(card => {
        card.addEventListener('click', () => {

            // Don't allow sold-out products
            if (card.dataset.available === 'false') {
                return;
            }

            const variantId = card.dataset.variantId;
            const image = card.dataset.image;
            const price = Number(card.dataset.price);
            const comparePrice = Number(card.dataset.comparePrice);

            if (!variantId) {
                alert('Variant ID Missing');
                return;
            }

            const btn = card.querySelector('.add-to-cart-byob');

            // REMOVE SELECTED PRODUCT
            if (card.classList.contains('is-selected')) {

                card.classList.remove('is-selected');

                if (btn) {
                    btn.innerText = 'Add to Box';
                }

                selectedVariants = selectedVariants.filter(
                    item => item.id !== variantId
                );

            } else {

                // MAXIMUM 8 PRODUCTS
                if (selectedVariants.length >= MAX_PRODUCTS) {
                    alert('You can select a maximum of 8 products');
                    return;
                }

                // ADD PRODUCT
                card.classList.add('is-selected');

                if (btn) {
                    btn.innerText = 'Remove From Box';
                }

                selectedVariants.push({
                    id: variantId,
                    image: image,
                    price: price,
                    comparePrice: comparePrice
                });

                // CONFETTI AT 2, 4, 6 AND 8 PRODUCTS
                if (
                    selectedVariants.length >= 2 &&
                    selectedVariants.length % 2 === 0
                ) {
                    if (typeof confetti === 'function') {
                        confetti({
                            particleCount: 150,
                            angle: 60,
                            spread: 80,
                            origin: {
                                x: 0,
                                y: 0.7
                            }
                        });

                        confetti({
                            particleCount: 150,
                            angle: 120,
                            spread: 80,
                            origin: {
                                x: 1,
                                y: 0.7
                            }
                        });
                    }
                }
            }

            updateUI();
        });
    });

    // REFRESH CART UI
    async function refreshCartUI() {
        try {
            await fetch('/cart.js');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', {
                    bubbles: true
                })
            );

            const cartDrawer = document.querySelector('cart-drawer');

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                const response = await fetch('/cart.js');
                const cart = await response.json();
                cartDrawer.renderContents(cart);
            }
        } catch (e) {
            console.log('Cart Refresh Failed', e);
        }
    }

    // WAIT FOR GOKWIK
    async function waitForGoKwik() {
        return new Promise(resolve => {
            let tries = 0;
            const interval = setInterval(() => {
                tries++;
                if (window.Gokwik || window.gokwikSdk) {
                    clearInterval(interval);
                    resolve(true);
                }

                const gokwikBtn = document.querySelector('#gokwik-buy-now') || document.querySelector('.gokwik-checkout') || document.querySelector('[class*="gokwik"]') || document.querySelector('[id*="gokwik"]');

                if (gokwikBtn) {
                    clearInterval(interval);
                    resolve(true);
                }

                if (tries > 30) {
                    clearInterval(interval);
                    resolve(false);
                }
            }, 1000);
        });
    }

    // OPEN GOKWIK
    async function openGoKwik() {
        await refreshCartUI();
        await new Promise(resolve =>
            setTimeout(resolve, 3000)
        );
        try {
            if (window.Gokwik && typeof window.Gokwik.checkout === 'function') {
                window.Gokwik.checkout();
                return true;
            }
        } catch (e) {
            console.log(e);
        }

        try {
            if (window.Gokwik && typeof window.Gokwik.openCheckout === 'function') {
                window.Gokwik.openCheckout();
                return true;
            }
        } catch (e) {
            console.log(e);
        }
        const gokwikBtn = document.querySelector('#gokwik-buy-now') || document.querySelector('.gokwik-checkout button') || document.querySelector('.gokwik-checkout') || document.querySelector('[class*="gokwik"] button') || document.querySelector('[class*="gokwik"]') || document.querySelector('[id*="gokwik"]');

        if (gokwikBtn) {
            gokwikBtn.removeAttribute('disabled');
            gokwikBtn.click();
            return true;
        }
        return false;
    }

    // Add to Box
    addBtn.addEventListener('click', async () => {
        if (selectedVariants.length < 2 || selectedVariants.length % 2 !== 0) {
            alert('Please select products in pairs to unlock Buy 1 Get 1 FREE');
            return;
        }
        try {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Preparing Checkout...';

            // CHECK CART
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();

            // CLEAR CART
            if (cartData.items && cartData.items.length > 0) {
                await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });
                await new Promise(resolve =>
                    setTimeout(resolve, 1500)
                );
            }

            addBtn.innerHTML = 'Adding Products...';
            const items = selectedVariants.map(item => ({
                id: Number(item.id),
                quantity: 1
            }));

            // ADD ITEMS
            const response =
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        items
                    })
                });

            if (!response.ok) {
                throw new Error('Add to Box Failed');
            }

            await new Promise(resolve => setTimeout(resolve, 1500));
            await refreshCartUI();

            window.history.pushState({}, '', window.location.pathname);

            await new Promise(resolve => setTimeout(resolve, 3000));
            await waitForGoKwik();

            addBtn.innerHTML = 'Opening Checkout...';
            const opened = await openGoKwik();

            if (!opened) {
                alert('Unable to open GoKwik checkout');
            }

            setTimeout(() => {
                addBtn.disabled = false;
                addBtn.innerHTML = 'Add to Box';
            }, 3000);

        } catch (error) {
            console.error(error);
            alert('Something went wrong');
            addBtn.disabled = false;
            addBtn.innerHTML = 'Add to Box';
        }
    });

    document.addEventListener('submit', function(e) {
        const form = e.target;
        if (form.action && ( form.action.includes('/cart') || form.action.includes('/checkout'))) {
            e.preventDefault();
        }
    });

    const originalAssign = window.location.assign;
    window.location.assign = function(url) {
        if ( url.includes('/cart') || url.includes('/checkout')) {
            return;
        }

        originalAssign.call(window.location, url);
    };

    const searchInput = document.querySelector('.byob-search');
    const productContainer = document.querySelector('.byob-main');

    document.querySelectorAll('.byob-product-col').forEach((card,index)=>{
        card.dataset.originalIndex = index;
    });

    function debounce(func, delay = 300) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this,args);
            },delay);
        };
    }

    const handleSearch = debounce((searchValue)=>{
        const cards = [...document.querySelectorAll('.byob-product-col')];
        const keyword = searchValue.toLowerCase().trim();
        if(!keyword){
            cards.sort((a,b)=>{
                return (Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));
            });
            cards.forEach(card=>{
                card.style.display='';
                productContainer.appendChild(card);
            });
            const noResult =document.querySelector('.search-empty');
            if(noResult){
                noResult.remove();
            }
            return;
        }
        const matched = [];
        const unmatched = [];
        cards.forEach(card=>{
            const title = card.querySelector('.byob-product-title')?.innerText.toLowerCase() || '';
            if(title.includes(keyword)){
                matched.push(card);
            }else{
                unmatched.push(card);
            }
        });

        const oldMessage = document.querySelector('.search-empty');
            if(oldMessage){
                oldMessage.remove();
            }

            [...matched,...unmatched].forEach(card=>{
                productContainer.appendChild(card);
            });

            matched.forEach(card=>{
                card.style.display='';
            });

            unmatched.forEach(card=>{
                card.style.display='';
            });

            if(matched.length === 0){
                const empty = document.createElement('p');
                empty.className = 'search-empty';
                empty.innerText = 'No products found';
                productContainer.appendChild(empty);
            }
        },300
    );

    if(searchInput){
        searchInput.addEventListener('input', function(e){
            handleSearch(e.target.value);
        });
    }

    const showMoreBtn = document.getElementById('byob-show-more');
    let visibleCount = 20;
    const loadCount = 20;

    productCards.forEach((card,index)=>{
        if(index >= visibleCount){
            card.classList.add('hidden-product');
        }
    });

    function loadProducts(){
        const hiddenProducts = document.querySelectorAll(
            '.byob-product-col.hidden-product'
        );
        for(let i=0;i<loadCount;i++){
            if(hiddenProducts[i]){
                hiddenProducts[i].classList.remove(
                    'hidden-product'
                );
            }
        }

        const remainingProducts = document.querySelectorAll(
            '.byob-product-col.hidden-product'
        );

        if(!remainingProducts.length && showMoreBtn){
            showMoreBtn.style.display='none';
        }
    }

    if(showMoreBtn){
        showMoreBtn.addEventListener('click', loadProducts);
    }

    window.addEventListener('scroll', ()=>{
        if(!showMoreBtn) return;

        const rect = showMoreBtn.getBoundingClientRect();
        if(rect.top <= window.innerHeight + 100 && showMoreBtn.style.display !== 'none'){
            loadProducts();
        }
    });

    updateUI();
});